import { module } from 'angular';

import { PAGE_MODAL_CONTROLLER } from './pageApplicationOwner.modal.controller';
import { PAGER_DUTY_READ_SERVICE } from './pagerDuty.read.service';
import { PAGER_DUTY_WRITE_SERVICE } from './pagerDuty.write.service';

export const PAGER_DUTY_MODULE = 'spinnaker.core.pagerDuty';
module(PAGER_DUTY_MODULE, [
  PAGE_MODAL_CONTROLLER,
  PAGER_DUTY_READ_SERVICE,
  PAGER_DUTY_WRITE_SERVICE,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pagerDuty/pagerDuty.module.ts